import {getConnection, getCurSession} from '../../../../../_shared/GWTBridge/invoke/bpm/bpmMain';
import {buildServerCall} from '../../../../../services/wcfService';

export const fetchDateChoosesOld = async (field: string, editvalue = '') => {
    const parameters = {
        session: [getCurSession()],
        id: [field],
        mode: ['0'],
        editvalue: [editvalue]
    };

    const res: any = await buildServerCall(
        'BPMChoose',
        parameters,
        'BPMChoose',
        true,
        getConnection
    );

    const data = res.BPM[0];

    if (data.Choose) {
        return (
            data.Choose?.[0]?.ChooseLine?.map(item => {
                return {
                    label: item.retval,
                    value: item.str1
                };
            }) || []
        );
    }
    return [];
};

export const fetchAdditionalChooseOld = async (field: string, editvalue = '') => {
    const parameters = {
        session: [getCurSession()],
        id: [field],
        mode: ['0'],
        editvalue: [editvalue]
    };

    const res: any = await buildServerCall(
        'BPMChoose',
        parameters,
        'BPMChoose',
        true,
        getConnection
    );

    const data = res.BPM[0];

    if (data.Choose) {
        return data.Choose[0];
    } else if (data.Search) {
        return data.Search[0];
    }
    return {
        ChooseLine: []
    };
};

export const fetchAdditionalSearchOld = async (
    field: string,
    mode: string = '',
    editvalue?: string
) => {
    const parameters = {
        session: [getCurSession()],
        id: [field],
        mode: [mode],
        editvalue: [editvalue]
    };

    const res: any = await buildServerCall(
        'BPMSearch',
        parameters,
        'BPMSearch',
        true,
        getConnection
    );

    const data = res.BPM[0];

    if (data.Search) {
        return data.Search[0];
    }
    return {
        ChooseLine: []
    };
};

export async function bpmSearchNextPage(field: string, page: string, searchQuery: string = '') {
    const methodName = 'BPMSearchPage';
    const reason = 'BPM search scroll';

    const parameters = {
        session: [getCurSession()],
        id: [field],
        page: [page],
        editvalue: [searchQuery]
    };
    const res: any = await buildServerCall(methodName, parameters, reason, true, getConnection);

    const data = res.BPM[0];

    if (data.Search) {
        return data.Search[0];
    }
    return {
        ChooseLine: []
    };
}
